import { render, staticRenderFns } from "./NewList.vue?vue&type=template&id=5cbb7aef&scoped=true"
import script from "./NewList.vue?vue&type=script&lang=js"
export * from "./NewList.vue?vue&type=script&lang=js"
import style0 from "./NewList.vue?vue&type=style&index=0&id=5cbb7aef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbb7aef",
  null
  
)

export default component.exports